module.exports = "/fonts/line-awesome.svg?e8f3746bfd3d718eb0a6b893da8b5bc8";